<template>
<div>
  <h1 class="push-double--top">{{ $_('campaign_move') }}</h1>
  <div class="card card--large push-double--bottom">
    <form class="form">
      <label for="move_to">{{ $_('campaign_move_p') }}</label>
      <div class="grid">
        <div class="grid__item one-third portable--one-whole">
          <div class="form__line flush--bottom">
            <div class="form__field flush--bottom">
              <label for="move_to">&nbsp;</label>
              <select name="move_to" id="move_to" class="field field--select" v-model="moveTo">
                <option v-for="option in accounts" v-bind:key="option.id" v-bind:value="option.id">
                  {{ option.company_name }} ({{ option.id }})
                </option>
              </select>
            </div>
          </div>
        </div><div class="grid__item one-half portable--one-whole">
          <div class="form__line flush--bottom flush--bottom">
            <button type="button" class="button button--primary push-half--top" style="position: relative; top: 4px;" :disabled="!moveTo || loading" @click="moveCampaign()">{{ $_('move') }} <i class="fa fa-spin fa-spinner" v-if="loading"></i></button>
          </div>
        </div>
      </div>
      <div class="form__line flush--bottom push-half--top" v-if="err.length">
        <div class="form__field">
          <div class="parsley-error" v-for="error in err" v-bind:key="error">{{ error }}</div>
        </div>
      </div>
    </form>
  </div>
</div>
</template>

<script>

var urlParser = document.createElement('a');
urlParser.href = location.href;

export default {
  props: {
    campaign: Object,
  },
  data () {
    return {
      client: {
        id: parseInt(urlParser.pathname.split('/')[2], 10)
      },
      accounts: [],
      moveTo: null,
      err: [],
      loading: false,
    }
  },
  mounted () {
    this.getAccounts();
    console.log(this.campaign);
  },
  methods: {
    getAccounts: function() {
      let self = this;
      self.$http.get("/api/v1/"+ self.client.id +"/clients/getAccountsForMerge").then(
        function(response) {
          self.accounts = Object.values(response.data.clients);
        },
        function(error) {
          console.error(error);
          self.err = [error.response.data];
        }
      )
    },
    moveCampaign: function() {
      let self = this;
      let moveToName = self.accounts.filter((a) => a.id == self.moveTo)[0]['company_name'];
      if (!confirm(this.$_('campaign_move_warning') + moveToName + '?')) return;
      self.loading = true;
      self.$http.post(`/api/v1/clients/${self.client.id}/campaigns/${self.campaign.id}/move/${self.moveTo}`).then(
        function(response) {
          window.location.href = `/clients/${self.moveTo}/campaigns`;
          self.loading = false;
        },
        function(error) {
          console.error(error);
          self.err = [error.response.data];
          self.loading = false;
        }
      )
    },
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/CampaignMove.vue